import styled from "styled-components";
import { ThemeType } from "../../types/Theme";
import background from "../../assets/newImages/background/bg.png";

const ContainerPagSeguroAutorizado = styled.div<{ theme: ThemeType }>`
  .bg-autenticacao-pagseguro{
    background-image: url(${background});
    background-size: cover;
    background-position: center;
    height: 100vh;
    width: 100vw;

    .conteudo-autenticacao{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;

      .card-autenticacao{
        width: auto;
        height: auto;
        border: 1px solid ${(props) => props.theme.colors.secondary};
        background-color: rgba(234, 234,234, 0.40);
        border-radius: 32px;
        padding: 80px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 48px;

        .titulo-autenticacao{
          color: ${(props) => props.theme.colors.primary};
          text-align: center;
          font-weight: 700;
          margin: 0;
        }

        .logos-autenticacao{
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;

          .mais{
            color: ${(props) => props.theme.colors.primary};
            font-weight: 700;
          }
        }

        .texto-complementar{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 16px;
          color: ${(props) => props.theme.colors.tertiary};

          .texto-complementar-negrito{
            font-weight: 700;
          }
        }
      }
    }
  }
`;

export { ContainerPagSeguroAutorizado };
